import React from 'react';
import { Container, Paper, Toolbar, Box } from '@mui/material';
import { Routes, Route, useParams } from 'react-router-dom';

import Spaces from './spaces';
import Space from './space';
import NewSpace from './newspace';

import { userSelector } from 'helper/security';

/**
 * Spaces module router component handling routes for space list, creation, and detail views.
 * Creation and detail routes are only accessible to admin/root users.
 */
export default function SpacesIndex() {
  const user = userSelector();

  return (
    <>
      <Toolbar />
      <Container maxWidth="xl">
        <Paper>
          <Box p={2}>
            <Routes>
              <Route index element={<Spaces />} />
              {user && (user.isAdmin || user.isRoot) && (
                <>
                  <Route path="_create" element={<NewSpace />} />
                  <Route path=":id" Component={() => <Space id={parseInt(useParams().id!)} />} />
                </>
              )}
            </Routes>
          </Box>
        </Paper>
      </Container>
    </>
  );
}
